/* MiCuadro - Predictive search (sugerencias en vivo)
   Se engancha a la barra de la lupa (#mcSearchMobileBar / #mcSearchMobileInput)
   y trae sugerencias usando la API nativa de Shopify /search/suggest.json.
   No depende de nada de Dawn ni de apps. */
(function () {
  function init() {
    var bar = document.getElementById('mcSearchMobileBar');
    var input = document.getElementById('mcSearchMobileInput');
    if (!bar || !input) return;

    var form = bar.querySelector('form');
    var searchUrl = (form && form.getAttribute('action')) || '/search';

    var box = document.createElement('div');
    box.className = 'mc-psr';
    box.setAttribute('role', 'listbox');
    box.style.display = 'none';
    bar.appendChild(box);

    var timer = null, lastQ = '', controller = null;

    function hide() { box.style.display = 'none'; box.innerHTML = ''; }
    function esc(s) {
      return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function render(q, products) {
      var html = '';
      if (products.length) {
        html += '<div class="mc-psr-head">Productos</div>';
        products.forEach(function (p) {
          var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
          var thumb = img
            ? '<img class="mc-psr-img" src="' + img + '" alt="" loading="lazy">'
            : '<span class="mc-psr-img mc-psr-img--ph"></span>';
          html += '<a class="mc-psr-item" href="' + p.url + '">' + thumb +
                  '<span class="mc-psr-title">' + esc(p.title) + '</span></a>';
        });
      } else {
        html += '<div class="mc-psr-empty">Sin resultados para "' + esc(q) + '"</div>';
      }
      html += '<a class="mc-psr-all" href="' + searchUrl + '?q=' + encodeURIComponent(q) +
              '&type=product&options%5Bprefix%5D=last">Buscar "' + esc(q) +
              '"<span class="mc-psr-arrow">&rarr;</span></a>';
      box.innerHTML = html;
      box.style.display = 'block';
    }

    function fetchSuggest(q) {
      if (controller && controller.abort) { try { controller.abort(); } catch (e) {} }
      controller = ('AbortController' in window) ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
                '&resources[type]=product&resources[limit]=6' +
                '&resources[options][unavailable_products]=last' +
                '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (q !== lastQ) return;
          var products = (data && data.resources && data.resources.results &&
                          data.resources.results.products) || [];
          render(q, products);
        })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      lastQ = q;
      if (timer) clearTimeout(timer);
      if (q.length < 2) { hide(); return; }
      timer = setTimeout(function () { fetchSuggest(q); }, 160);
    });

    document.addEventListener('click', function (e) {
      if (!bar.contains(e.target)) hide();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hide();
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
